export default __webpack_public_path__ + "static/media/litho-demo-furniture-shop.e8ba6d97.jpg";